module.exports = __webpack_public_path__ + "img/baoxiaomi-opk-weather.3ddfc0f5.png";